import Vue from 'vue/dist/vue.esm.js'

KCVS.Views.ReportFileGroups = Vue.extend(
  template: JST['report_file_groups/report_file_groups']()
  data: ->
    reportFileGroups: []
    reportFilesByGroups: {}
    expandedGroups: {}
    tableHeaders: []
    pprpId: null
    groupPages: {}
    draggingFileId: null
    draggingGroupId: null

  created: ->
    @fetchAllGroupFiles()

    EventBus.$on 'dragging-file-started', (fileId, groupId) =>
      @draggingFileId = fileId
      @draggingGroupId = groupId

    EventBus.$on 'refetch-all-groups', =>
      @refetchOnlyGroupFiles()

    EventBus.$on 'update-files-after-group-change', (newGroupId, oldGroupId) =>
      setTimeout =>
        @fetchFilesForGroup(newGroupId)
        @fetchFilesForGroup(oldGroupId)
      , 200

  methods:
    toggleExpand: (groupId) ->
      @.$set(@expandedGroups, groupId, !@expandedGroups[groupId])

    allowDrop: (event) ->
      event.preventDefault()
      event.currentTarget.classList.add('selection-highlight')

    onFileDrop: (event) ->
      @removePlaceholderClass(event)
      EventBus.$emit('file-dropped-on-group-header', event.toElement.id, @draggingFileId)
      @refetchOnlyGroupFiles()

    removePlaceholderClass: (event) ->
      event.currentTarget.classList.remove('selection-highlight')

    refetchOnlyGroupFiles: ->
      @reportFileGroups.forEach (group) =>
        @.$set(@reportFilesByGroups, group.id, [])
        @fetchFilesForGroup(group.id)

    fetchFilesForGroup: (groupId, page = 1) ->
      @loading = true
      $.ajax
        dataType: 'JSON',
        url: "/project_partner_report_periods/#{@pprpId}/report_files/report_files_by_group"
        method: 'GET'
        data: {
          group_id: groupId,
          page: page
        }
        success: (response) =>
          @reportFilesByGroups[groupId] = response.files
          @groupPages[groupId] =
            currentPage: response.current_page
            totalPages: response.total_pages
          @loading = false
        error: (response) =>
          console.log(response)

    fetchAllGroupFiles: ->
      @reportFileGroups.forEach (group) =>
        @.$set(@expandedGroups, group.id, group.is_default_group)
        @.$set(@reportFilesByGroups, group.id, [])
        @.$set(@groupPages, group.id, [])
        @fetchFilesForGroup(group.id)

    handlePageChange: (hash) ->
      @fetchFilesForGroup(hash.groupId, hash.page)

  components:
    ReportFileGroupTable: KCVS.Views.ReportFileGroupTable
    GroupPagination: KCVS.Views.ReportFileGroupPagination
)
